/** Inline CSS variable styles — avoids Tailwind JIT purging custom color utilities in dev */
export const tc = {
  primary: { color: "var(--color-text-primary)" },
  muted: { color: "var(--color-text-muted)" },
  accent: { color: "var(--color-accent-bright)" },
  danger: { color: "var(--color-danger)" },
};

export const tb = {
  page: { background: "var(--color-bg)" },
  surface: { background: "var(--color-surface)" },
  surfaceHover: { background: "var(--color-surface-hover)" },
  accent: { background: "var(--color-accent)" },
  accentBright: { background: "var(--color-accent-bright)" },
};

export const tbr = {
  default: { borderColor: "var(--color-border)" },
  accent: { borderColor: "var(--color-accent)" },
  topAccent: { borderTopColor: "var(--color-accent)" },
};

export const merge = (...styles) => Object.assign({}, ...styles.filter(Boolean));
